import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const DepositSlip = () => {
    const pdfRef = useRef();

    // Temporary Static Data
    const franchiseName = "Komal Ruchi";
    const mobile = "9876543210";
    const amount = 100;
    const amountWords = "One Hundred Rupees Only";
    const date = "17/11/2025";
    const mode = "UPI";
    const transactionId = "TXN-5538291";

    const downloadPDF = async () => {
        const input = pdfRef.current;

        // 👇 Better Quality Render Settings
        const canvas = await html2canvas(input, {
            scale: 2,
            useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // 👇 Center Image
        const x = (pageWidth - imgWidth) / 2;

        pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
        pdf.save(`DepositSlip_${franchiseName}.pdf`);
    };

    return (
        <div className="p-6">
            {/* DOWNLOAD BUTTON */}
            {/* <button
                onClick={downloadPDF}
                className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 transition mb-5"
            >
                Download PDF
            </button> */}

            {/* LETTER BODY */}
            <div
                ref={pdfRef}
                style={{
                    width: "210mm",
                    minHeight: "297mm",
                    padding: "20mm",
                    boxSizing: "border-box",
                    background: "white",
                }}
                className="shadow-lg border"
            >
                {/* Header */}
                <div className="flex justify-center items-center gap-3 w-full text-center">
                    <img
                        src="/logo192.png"
                        alt="Company Logo"
                        style={{ width: "50px", height: "50px" }}
                    />
                    <div>
                        <h1 className="text-xl font-bold tracking-wide text-start">AlgarXpress™</h1>
                        <p className="text-sm font-normal">India's Largest Logistics Network - Fast & Reliable Shipping</p>
                        <p className="text-sm font-normal text-start">PREPAID • CASH ON DELIVERY • INTERNATIONAL</p>
                    </div>
                </div>

                <p className="text-center text-sm mt-2">
                    123 Corporate Park, Ring Road, Surat – 395003, Gujarat, India<br />
                    Email: algarxpress@gmail.com | Helpline: +91 98765 43210
                </p>

                <hr className="my-4" />

                {/* Date */}
                <p className="text-right text-sm font-semibold">Date: {date}</p>

                <p className="mt-4">To,</p>
                <p className="font-semibold">{franchiseName}</p>
                <p>Mobile Number: {mobile}</p>

                <p className="mt-4 font-semibold">
                    Subject: Official Acknowledgement of Deposit Received
                </p>

                {/* Body Text */}
                <p className="mt-4 leading-7 text-sm">
                    Dear Sir/Madam,
                    <br /><br />
                    This is to officially acknowledge and confirm that a deposit amount of <b>₹{amount} ({amountWords})</b> has been successfully received from you on <b>{date}</b> toward your franchise account with AlgarXpress.
                    <br />
                    The payment mode is <b>{mode}</b> and Transaction/Reference ID is <b>{transactionId}</b>.
                </p>

                <p className="mt-3 font-semibold">Please Note the Following Terms:</p>

                <ul className="text-sm leading-6 list-disc pl-6">
                    <li>The deposit is non-transferable to another franchise without written approval.</li>
                    <li>Refund will be issued only after all dues are cleared and verified.</li>
                    <li>This deposit confirms agreement to operate under company policies and guidelines.</li>
                    <li>The deposited amount remains linked to franchise until termination or settlement.</li>
                    <li>
                        By sending this deposit, you confirm that you have read all terms and conditions
                        carefully before transferring the amount.
                    </li>
                    <li>
                        You also agree to follow all company rules and give full consent to uphold
                        operational policies without objection.
                    </li>
                </ul>

                <p className="mt-4 text-sm">
                    Keep this letter for official records. If any correction needed, contact within 48 hours.
                </p>

                <p className="mt-8">Warm Regards,</p>
                <p className="mt-10 font-semibold">___________________________</p>
                <p className="font-semibold">Authorized Signature</p>
                <p>AlgarXpress ™</p>

                <hr className="mt-6" />
            </div>
        </div>
    );
};

export default DepositSlip;
